import type {PositionablePosition} from '@travel-frontend/ui-components';

import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Positionable} from '@travel-frontend/ui-components';

import {Container} from '@/components/ImageGalleryNextControl/components/Container';

export type Props = React.PropsWithChildren<
  React.ComponentProps<typeof Positionable> & {
    highlighted: boolean;
    position: PositionablePosition;
    'aria-label'?: string;
  }
>;

export const Control = styled(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- unused var intended
  ({highlighted, children, ...restProps}: Props) => (
    <Positionable {...restProps} as="button">
      <Container>{children}</Container>
    </Positionable>
  )
)<Props>(({highlighted, theme}) => {
  const focusStyles = css`
    ${Container} {
      background-color: ${theme.colors.backgroundOverlay};
    }
  `;

  return css`
    display: flex;
    align-items: center;
    padding: 0 8px;

    box-sizing: border-box;
    border: 0;
    outline: none;
    background: inherit;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    ${highlighted && !theme.isAccessibleTheme && focusStyles};
    ${highlighted &&
    theme.isAccessibleTheme &&
    css`
      ${Container} {
        background-color: ${theme.colors.backgroundSecondary};
      }
    `}

    &:hover {
      ${!theme.isAccessibleTheme && focusStyles}
      ${theme.isAccessibleTheme &&
      css`
        ${Container} {
          background-color: ${theme.colors.backgroundTertiary};
        }
      `}
    }

    &:focus-visible {
      ${!theme.isAccessibleTheme && focusStyles}
      ${Container} {
        outline: ${theme.colors.focusState} dashed 2px;
        outline-offset: 2px;
      }
      ${theme.isAccessibleTheme &&
      css`
        ${Container} {
          background-color: ${theme.colors.backgroundSecondary};
        }
      `}
    }

    &:active {
      ${!theme.isAccessibleTheme &&
      css`
        ${Container} {
          background-color: rgba(255, 255, 255, 0.42);
        }
      `}
      ${theme.isAccessibleTheme &&
      css`
        ${Container} {
          background-color: ${theme.colors.backgroundTertiary};
          transform: scale(0.95);
        }
      `}
    }
  `;
});
